import { View } from 'foundations-components/components/View';
import { useLearningContentType } from '../learningContentQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const getMaxWidthForContent = contentType => contentType === 'VIDEO' ? '100%' : '850px';
export const LearningContentContainer = ({
  lessonId,
  trackId,
  language,
  contentId,
  children
}) => {
  const contentType = useLearningContentType({
    lessonId,
    trackId,
    language,
    contentId
  });
  const maxWidth = getMaxWidthForContent(contentType);
  return /*#__PURE__*/_jsx(View, {
    marginInline: "auto",
    maxInlineSize: maxWidth,
    position: "relative",
    children: children
  });
};